import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

interface ConfirmArchiveModalProps {
  isOpen: boolean;
  confirm: () => void;
  cancel: () => void;
}

export const ConfirmArchiveModal: React.FC<ConfirmArchiveModalProps> = ({
  isOpen,
  confirm,
  cancel,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={cancel}
    title="Archive this offer"
    modalClassName="w-full md:w-[670px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        Are you sure you want to archive this offer? It will be removed from
        your Landing Page and your users will no longer be able to purchase it.
        Past purchasers will retain their access.
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={cancel}
          className="w-[180px]"
        >
          Cancel
        </Button>
        <Button color="error" onClick={confirm} className="w-[180px]">
          Archive
        </Button>
      </div>
    </div>
  </Modal>
);
